// KeywordsComponent.jsx
import React, { useState } from 'react';
import { Switch, message } from 'antd';
import axios from 'axios';

const BASE_URL = 'http://127.0.0.1:8000/booleanSearch/booleanSearch/'; // Update with your backend URL

const performBooleanSearch = async (query) => {
  try {
    const response = await axios.post(`${BASE_URL}`, { query });
    return response.data.results;
  } catch (error) {
    console.error("Error performing Boolean search:", error.response?.data || error.message);
    throw error;
  }
};

function KeywordsComponent({
  keywords,
  currentKeyword,
  handleAddKeyword,
  handleRemoveKeyword,
  toggleStar,
  clearAllKeywords,
  setCurrentKeyword,
}) {
  const [toggle, setToggle] = useState(false);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const toggler = () => {
    setToggle(!toggle);
  };

  const handleKeywordChange = (e) => {
    setCurrentKeyword(e.target.value);
  };

  const handleSearch = async () => {
    if (!currentKeyword) {
      message.warning("Please enter a search query.");
      return;
    }

    try {
      setLoading(true);
      const searchResults = await performBooleanSearch(currentKeyword);
      setResults(searchResults);
      message.success("Search completed successfully!");
    } catch (error) {
      message.error("Failed to perform the search. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mb-4">
      <div className="flex justify-between items-center flex-col sm:flex-row">
        <label className="block text-gray-700 font-bold">Keywords</label>
        <div className="flex items-center">
          <Switch onClick={toggler} />
          {toggle ? <span> Boolean On </span> : <span>Boolean Off</span>}
        </div>
      </div>

      {/* Keyword Input */}
      <div className="relative flex items-center">
        <input
          type="text"
          value={currentKeyword}
          onChange={handleKeywordChange}
          placeholder="(Java OR 'Net') AND React AND Angular"
          className="w-full border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2"
        />

        <button
          type="button"
          onClick={handleSearch}
          className="absolute right-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-700 mt-2"
          disabled={loading}
        >
          {loading ? "Searching..." : "Search"}
        </button>
      </div>

      {/* Results Display */}
      <div className="mt-4">
        <h3 className="text-lg font-bold">Search Results:</h3>
        {results.length > 0 ? (
          <ul className="list-disc pl-5">
            {results.map((result, index) => (
              <li key={index}>{result}</li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-500">No results found.</p>
        )}
      </div>
    </div>
  );
}

export default KeywordsComponent;